import React, { useState, useContext, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import axios from 'axios'
import { FirebaseContext } from '../firebase'
import Card from 'react-bootstrap/Card'
import { useHistory } from 'react-router-dom'
import useFormValidation from '../auth/useFormValidation'
import validateCreateLink from '../auth/validateCreateLink'
import { LinkContainer } from 'react-router-bootstrap'
import firebase from 'firebase'

const INITIAL_STATE = {
    url: "",
}

function Create() {
    const history = useHistory()
    const [sequences, setSequences] = useState([])
    const [selectedSequence, setSelectedSequence] = useState("")
    const { fire, user } = useContext(FirebaseContext)
    const { handleChange, handleSubmit, handleBlur, values, errors, isSubmitting } = useFormValidation(INITIAL_STATE, validateCreateLink)

    // function getQueryStringValue(key, queryString = window.location.search) { 
    //     const values = qs.parse(queryString)
    //     return values[key]
    // }

    // function useQueryString(key, initialValue) {
    //     const [value, setValue] = useState(getQueryStringValue(key) || initialValue)
    //     const onSetValue = useCallback(
    //         newValue => {
    //           setValue(newValue);
    //         //   setQueryStringValue(key, newValue);
    //         },
    //         [key]
    //       );

    //       return [value, onSetValue];
    // }

    useEffect(() => {
        if (user) {
            getUserSequences()
        }
    }, [user])

    function getUserSequences() {
        fire.firestore().collection('sequences').where("createdBy", "==", user.uid).get().then(handleSnapshot)
    }

    function handleSnapshot(snapshot) {
        setSequences(snapshot.docs.map(doc => {
            return {
                id: doc.id,
                ...doc.data()
            }
        }))
    }

    function onSubmit(event) {
        event.preventDefault()
        const data = {
            'url': values.url,
            'sequence': selectedSequence,
            'created': Date.now()
        }
        fire.firestore().collection('articles').add(data)
            .then(docRef => {
                axios.get(`https://us-central1-react-sequences.cloudfunctions.net/getTitle?articleId=${docRef.id}`)
                    .then(resp => {
                        console.log(resp.data)
                    })
                fire.firestore().collection('sequences').doc(selectedSequence)
                    .update({
                        'articles': firebase.firestore.FieldValue.arrayUnion(docRef.id)
                    })
            }).catch(err => console.log(err))
        history.push(`/sequence/${selectedSequence}`)
    }

    return (
        <Container>
            <Card className="m-2 mt-4">
                <Card.Header as="h5">Add an article to Sequences</Card.Header>
                <Card.Body>
                    <Card.Title as="h6">Add any website, article, or video by pasting the link below.</Card.Title>
                    <Form onSubmit={e => handleSubmit(e, onSubmit)}>
                        <Form.Group>
                            <Form.Control
                                type="url"
                                placeholder="Paste your link here"
                                autoComplete="off"
                                onChange={handleChange}
                                name="url"
                                className={errors.url && 'error-input'}
                                onBlur={handleBlur}
                                value={values.url} />
                            {errors.url && <p className="error-text">{errors.url}</p>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Row>
                                <Col>
                                    <Form.Control
                                        as="select"
                                        name="selectedSequence"
                                        defaultValue="Select a sequence to add the link to..."
                                        onChange={e => {
                                            let index = e.target.selectedIndex
                                            let el = e.target.childNodes[index]
                                            let optionId = el.getAttribute('id')
                                            setSelectedSequence(optionId)
                                        }}>
                                        <option disabled>Select a sequence to add the link to...</option>
                                        {sequences.map((sequence, index) => (
                                            <option id={sequence.id} key={index}>{sequence.name}</option>
                                        ))}
                                    </Form.Control>
                                    {errors.setSequences && <p className="error-text">{errors.url}</p>}
                                </Col>
                                <Col className="d-none d-sm-block" sm={3}>
                                    <LinkContainer to="/create/sequence">
                                        <Button variant="secondary" block>Create a new Sequence</Button>
                                    </LinkContainer>
                                </Col>
                            </Form.Row>
                        </Form.Group>
                        <Button className="d-none d-sm-block" variant="primary" type="submit" disabled={isSubmitting}>Add link</Button>
                        <div className="d-block d-sm-none mobile-view">
                            <Button block variant="primary" type="submit" disabled={isSubmitting}>Add link</Button>
                            <LinkContainer to="/create/sequence">
                                <Button variant="secondary" block>Create a new Sequence</Button>
                            </LinkContainer>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    )
}

export default Create